module.exports = __webpack_public_path__ + "static/bg-gradient-02-1c3878238fcc9bca3e5bbbe19af6f8bd.png";